import { createSvgIcon } from '@mui/material/utils';
import React from 'react';

export const LayoutDashboard = createSvgIcon(
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.5 10C7.98528 10 10 7.98528 10 5.5C10 3.01472 7.98528 1 5.5 1C3.01472 1 1 3.01472 1 5.5C1 7.98528 3.01472 10 5.5 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M5.5 23C7.98528 23 10 20.9853 10 18.5C10 16.0147 7.98528 14 5.5 14C3.01472 14 1 16.0147 1 18.5C1 20.9853 3.01472 23 5.5 23Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 10C20.9853 10 23 7.98528 23 5.5C23 3.01472 20.9853 1 18.5 1C16.0147 1 14 3.01472 14 5.5C14 7.98528 16.0147 10 18.5 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M18.5 23C20.9853 23 23 20.9853 23 18.5C23 16.0147 20.9853 14 18.5 14C16.0147 14 14 16.0147 14 18.5C14 20.9853 16.0147 23 18.5 23Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>,
  'LayoutDashboard'
);
